import { BaseModel } from "../../Bases/BaseModel";

export class UsuarioTecnologia extends BaseModel {
  constructor(
    public usuario_id = 0,
    public tecnologia_id = 0,
    public tecnologia_nome = ''

  ) {
    super();
  }
}


